"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMetabolicDiseases = createMetabolicDiseases;
const utils_1 = require("../../../events/utils");
const shared_1 = require("../../shared");
const queries_1 = require("../queries");
const metabolicDisease_1 = require("../../../forms/ktx/transplantation-screening/medical-history/metabolicDisease");
const messages = {
    title: {
        id: "ktx.dashboard.metabolic_diseases",
        defaultMessage: "Endokrin és anyagcsere betegségek"
    },
    diabetesType: {
        id: "ktx.dashboard.metabolic_diseases.diabetes_type",
        defaultMessage: "Diabetes típusa"
    },
    diabetesComplications: {
        id: "ktx.dashboard.metabolic_diseases.diabetes_complications",
        defaultMessage: "Szövődmények"
    },
    lipoproteinDisturbancesType: {
        id: "ktx.dashboard.metabolic_diseases.lipoprotein_disturbances_type",
        defaultMessage: "Típusa"
    }
};
function createMetabolicDiseases(intl, options) {
    const lists = createList(intl, options);
    const content = (0, shared_1.createGroupContent)(lists);
    return (0, shared_1.createGroup)(intl, { label: messages.title, content });
}
function createList({ formatMessage, formatMessageMap, formatDate }, { events }) {
    const relevantEvents = (0, utils_1.findEventsByQuery)(events, queries_1.medicalHistoryQueries.metabolicDiseases);
    return relevantEvents
        .map(event => {
        const { timestamp, origin } = event;
        const formattedTimestamp = formatDate(timestamp, {
            year: "numeric",
            month: "numeric",
            day: "numeric"
        });
        const items = [];
        if (typeof event.value === "string") {
            items.push({
                type: "list-item",
                value: formatMessageMap(metabolicDisease_1.hasDiseaseMessages, event.value)
            });
        }
        else {
            const diabetesComplications = event.value.diabetesComplication
                ? event.value.diabetesComplication
                    .map(c => formatMessageMap(metabolicDisease_1.diabetesComplicationMessages, c))
                    .join(", ")
                : "";
            items.push({
                type: "list-item",
                value: formatMessageMap(metabolicDisease_1.metabolicDiseaseTypeMessages, event.value.metabolicDiseaseType)
            });
            if (event.value.diabetesType) {
                items.push({
                    type: "list-item",
                    label: formatMessage(messages.diabetesType),
                    value: formatMessageMap(metabolicDisease_1.diabetesTypeMessages, event.value.diabetesType)
                });
            }
            if (event.value.diabetesComplication) {
                items.push({
                    type: "list-item",
                    label: formatMessage(messages.diabetesComplications),
                    value: diabetesComplications
                });
            }
            if (event.value.lipoproteinDisturbancesType) {
                items.push({
                    type: "list-item",
                    label: formatMessage(messages.lipoproteinDisturbancesType),
                    value: formatMessageMap(metabolicDisease_1.lipoproteinDisturbancesTypeMessages, event.value.lipoproteinDisturbancesType)
                });
            }
        }
        return {
            type: "list",
            attachments: (0, utils_1.mapEventsToAttachments)(event),
            timestamp: event.timestamp,
            label: `${formattedTimestamp}`,
            origin,
            items
        };
    })
        .sort(shared_1.compareByTimestamp);
}
